export default __webpack_public_path__ + "static/media/uniswap-white.a059ec00.png";